import { call, put } from 'redux-saga/effects';
import { getData } from '../../service/getDataService';
import APIENDPOINTS from '../../../constants/apiconstants';

import {
	getBusinessHierarchySuccess,
	getBusinessHierarchyFailure,
	getSavedHierarchySuccess,
	getSavedHierarchyFailure,
	saveHierarchySuccess,
	saveHierarchyFailure,
	deleteSavedHierarchySuccess,
	deleteSavedHierarchyFailure,
	editSavedHierarchySuccess,
	editSavedHierarchyFailure,
	setSelectedHierarchy,
	validateHierarchyFailure,
	validateHierarchySuccess,
	updateSavedHierarchyFailure,
	updateSavedHierarchySuccess,
} from '../../actions/fullCompanyViewAction';
import { saveData, patchData } from '../../service/saveDataService';
import actionTypes from '../../actionTypes';
import { selectedHierarchyRhId } from '../../utils.js';
import { checkUserAuth } from '../../../helper/utils.js';

export function* getBusinessHierarchy(action) {
	try {
		const { portalUserContext } = action.payload;

		const apiUrl = `${APIENDPOINTS.SEARCH_URL}/by/HIERARCHY?viewBy=RHID`;

		const response = yield call(getData, apiUrl, portalUserContext.result);
		if (response?.statusCode !== 200) {
			yield put(getBusinessHierarchyFailure(response?.statusCode));
		} else {
			yield put(getBusinessHierarchySuccess(response?.json));
			yield put({
				type: actionTypes.GET_SAVED_HIERARCHY,
				payload: {
					portalUserContext,
					bussinessHierarchyResponse: response?.json,
				},
			});
		}
	} catch (error) {
		yield put(getBusinessHierarchyFailure(error));
	}
}

export function* getSavedHierarchy(action) {
	const { portalUserContext, bussinessHierarchyResponse } = action.payload;
	try {
		const apiUrl = `${APIENDPOINTS.USER_PREF_URL}/v1/lookup`;

		const response = yield call(getData, apiUrl, portalUserContext.result);

		if (response?.statusCode !== 200) {
			const request = {
				bussinessHierarchyResponse,
				statusCode: response?.statusCode,
			};
			yield put(getSavedHierarchyFailure(request));
		} else {
			const request = {
				savedHierarchyResponse: response.json,
				bussinessHierarchyResponse,
			};
			yield put(getSavedHierarchySuccess(request));
		}
	} catch (error) {
		if (error.code === 'ECONNABORTED') {
			// handle timeout error
			yield put(
				getSavedHierarchyFailure({
					bussinessHierarchyResponse,
					statusCode: 1004,
				})
			);
		} else {
			yield put(
				getSavedHierarchyFailure({
					bussinessHierarchyResponse,
					statusCode: 0,
				})
			);
		}
	}
}

export function* saveHierarchy(action) {
	const { portalUserContext, request, isDefault } = action.payload;
	const isDefaultParam = isDefault ? `?default=${isDefault}` : '';
	const apiUrl = `${APIENDPOINTS.USER_PREF_URL}/v1/save${isDefaultParam}`;

	const response = yield call(
		saveData,
		request,
		apiUrl,
		portalUserContext.result
	);
	if (response?.statusCode !== 200) {
		yield put(saveHierarchyFailure(response));
	} else {
		yield put(saveHierarchySuccess(response));
		yield put(
			setSelectedHierarchy({
				name: request?.insightPreferences[0]?.name,
				hierarchyFilterRhId: selectedHierarchyRhId(
					request?.insightPreferences[0]
				),
			})
		);
	}
}

export function* validateHierarchy(action) {
	try {
		const { portalUserContext, request } = action.payload;
		const apiUrl = `${APIENDPOINTS.USER_PREF_URL}/v1/validate`;
		const response = yield call(
			saveData,
			request,
			apiUrl,
			portalUserContext.result
		);
		if (response?.statusCode > 200) {
			yield put(validateHierarchyFailure(response));
		} else {
			yield put(validateHierarchySuccess(response));
		}
	} catch (error) {
		yield put(validateHierarchyFailure(error));
	}
}

export function* deleteSavedHierarchy(action) {
	try {
		const { portalUserContext, request } = action.payload;
		const apiUrl = `${APIENDPOINTS.USER_PREF_URL}/v1/delete/${request.id}`;

		const response = yield call(
			patchData,
			request,
			apiUrl,
			portalUserContext.result
		);

		if (response?.statusCode > 200) {
			yield put(deleteSavedHierarchyFailure(response));
		} else {
			yield put(deleteSavedHierarchySuccess(response));
		}
	} catch (error) {
		yield put(deleteSavedHierarchyFailure(error));
	}
}

export function* editSavedHierarchy(action) {
	try {
		const { portalUserContext, request, editSelectedHierarchy } =
			action.payload;
		const apiUrl = `${APIENDPOINTS.USER_PREF_URL}/v1/edit`;
		const response = yield call(
			patchData,
			request,
			apiUrl,
			portalUserContext.result
		);
		if (response?.statusCode > 200) {
			yield put(editSavedHierarchyFailure(response));
		} else {
			if (editSelectedHierarchy) {
				yield put(
					setSelectedHierarchy({
						name: request?.insightPreferences[0]?.name,
						hierarchyFilterRhId: selectedHierarchyRhId(
							request?.insightPreferences[0]
						),
					})
				);
			}
			yield put(editSavedHierarchySuccess(response));
		}
	} catch (error) {
		yield put(editSavedHierarchyFailure(error));
	}
}

export function* updateSavedHierarchy(action) {
	try {
		const { portalUserContext, request } = action.payload;
		const hierarchy = request.insightPreferences[0];
		const apiUrl = `${APIENDPOINTS.USER_PREF_URL}/v1/update/${hierarchy.id}?default=${hierarchy.isDefault}`;
		const response = yield call(
			patchData,
			request,
			apiUrl,
			portalUserContext.result
		);
		if (response?.statusCode > 200) {
			yield put(updateSavedHierarchyFailure(response));
		} else {
			const updatedResponse = {
				...response,
				value: hierarchy.isDefault,
			};
			yield put(updateSavedHierarchySuccess(updatedResponse));
		}
	} catch (error) {
		yield put(updateSavedHierarchyFailure(error));
	}
}

export function* getUserAuth(action) {
	try {
		const { portalUserContext } = action.payload;
		const apiUrl = APIENDPOINTS.GET_USER_AUTH;
		const response = yield call(getData, apiUrl, portalUserContext.result);

		if (checkUserAuth(response?.data)) {
			yield put({
				type: actionTypes.GET_USER_AUTH_FAILURE,
				payload: {
					statusCode: 1003,
				},
			});
		}
	} catch (error) {
		yield put({
			type: actionTypes.GET_USER_AUTH_FAILURE,
			payload: {
				statusCode: 1003,
			},
		});
	}
}
